import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

export default class Toggle extends Component {
  static propTypes = {
    toggled: PropTypes.bool,
    onToggle: PropTypes.func
  };

  render() {
    const { toggled } = this.props;
    return (
      <Wrapper toggled={toggled} onClick={this.onClick}>
        <Circle />
        <Label>{this.props.toggled ? "Show" : "Hide"}</Label>
      </Wrapper>
    );
  }

  onClick = () => {
    const { toggled, onToggle } = this.props;
    if (onToggle) onToggle(!toggled);
  };
}

const Wrapper = styled.div`
  display: flex;
  width: 45px;
  height: 20px;
  border-radius: 10px;
  flex: none;
  padding: 1px;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
  ${props => {
    if (props.toggled) {
      return css`
        flex-direction: row;
        background-color: ${props.theme.blueButton};
      `;
    } else {
      return css`
        flex-direction: row-reverse;
        background-color: ${props.theme.grayButton};
      `;
    }
  }};
`;
const Circle = styled.div`
  flex: none;
  width: 18px;
  height: 18px;
  border-radius: 9px;
  background-color: white;
`;
const Label = styled.div`
  margin: auto;
  color: white;
  font-size: 0.6rem;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/common/Toggle.js